import { ChangeDetectorRef, Input } from '@angular/core';
import { EventEmitter, Output, ViewChild } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { DevicePilomat } from 'src/app/model/devicePilomat';
import { LogEvent } from 'src/app/model/logEvent';
import { DeviceService } from 'src/app/service/device.service';
import { UserService } from 'src/app/service/user.service';
import { Log } from 'src/app/util/log';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription, interval } from 'rxjs';
import { SerialsList } from '../model/serialsList';


@Component({
  selector: 'app-ota',
  templateUrl: './ota.component.html',
  styleUrls: ['./ota.component.css']
})
export class OtaComponent implements OnInit {

  @ViewChild('deviceslisttable', { static: true }) table;
  @ViewChild('deviceslistloader', { static: true }) loader;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns: string[] = ['name', 'serial', 'fwVersion', 'stateIcon', 'stateDescription', 'city', 'address', 'checkbox'];

  deviceList: DevicePilomat[];

  dataSource: MatTableDataSource<DevicePilomat>;

  serials: SerialsList;

  gotState: boolean = false;
  updating: boolean = false;

  timeInterval: Subscription;
  deviceStateSubscription: Subscription;

  selectedDevices: DevicePilomat[] = [];
  selectedDevicesCount: number = 0;

  currentyDoing1: string = "currentyDoing1";
  currentyDoing2: string = "currentyDoing2";
  currentyDoing3: string = "currentyDoing3";

  currentIndex: number = 0;

  recheckingCounter: number = 0;

  constructor(
    private deviceService: DeviceService,
    private userService: UserService,
    private snackBar: MatSnackBar,
    private cdRef: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    // setTimeout(() => {
    //   this.loader.showLoading();
    // });

    this.getDeviceList();
  }


  ngOnChanges(changes: SimpleChanges) {

    if (this.timeInterval) {
      this.timeInterval.unsubscribe();
    }
  }


  ngOnDestroy(): void {

    if (this.timeInterval) {
      this.timeInterval.unsubscribe();
    }

    if (this.deviceStateSubscription) {
      this.deviceStateSubscription.unsubscribe();
    }
  }




  getDeviceList() {

    Log.debug("getDeviceList");

    this.loader.showLoading();

    const obs = this.deviceService.getDevices();
    obs.subscribe(data => {

      this.deviceList = data;

      this.table.dataSource = new MatTableDataSource(this.deviceList);
      this.table.dataSource.sort = this.sort;
      // this.table.dataSource.filterPredicate = this.filterTable;

      this.cdRef.detectChanges();

      setTimeout(() => {
        this.startUpdatingDevicesStates();
      }, 500);


      this.loader.hideLoading();

    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
    });
  }


  startUpdatingDevicesStates() {

    this.serials = new SerialsList();

    for (let i = 0; i < this.deviceList.length; i++) {
      this.serials.devices.push(this.deviceList[i].serial);
    }

    setTimeout(() => {
      this.loader.hideLoading();
    }, 1250);

    //faccio un prime updateState per avere i dati all'avvio della pagina
    this.updateState();

    //timeInterval lo ripeterà ogni 15 secondi (parte 6 secondi dopo il caricamento della pagina)
    this.timeInterval = interval(15000).subscribe((res) => {
      this.updateState();
    });
  }

  updateState() {
    this.deviceStateSubscription = this.deviceService.getDevicesState(this.serials).subscribe((response) => {

      for (let i = 0; i < response.length; i++) {
        // TODO
        // Potrebbero non arrivare completi o in ordine
        // array.find(device.serial == response[i].serial){
        //   etc

        this.deviceList[i].updateState(response[i]);
        this.cdRef.detectChanges();
      }
      this.gotState = true;
    });
  }

  checkAll() {
    this.deviceList.forEach(device => {
      device.selected = true;
    });
  }

  uncheckAll() {
    this.deviceList.forEach(device => {
      device.selected = false;
    });
  }


  startOta() {
    this.updateLog("OTACOMPONENT: Start ota clicked");

    //se non ho ancora info sullo stato dei device attendo
    if (this.gotState && !this.updating) {

      //svuoto selecteDevices
      this.selectedDevices = [];
      this.updating = true;

      //aggiungo i device aggiunti a selectedDevices
      this.deviceList.forEach(device => {
        if (device.selected) {
          this.selectedDevices.push(device);
        }
      });

      this.selectedDevicesCount = this.selectedDevices.length;
      if (this.selectedDevicesCount > 0) {
        this.updateLog("OTACOMPONENT: begin ota process");
        this.otaDevice(0);
      } else {
        this.updateLog("OTACOMPONENT: no devices selected");

      }
    } else {
      this.updateLog("OTACOMPONENT: can´t start ota, ota already in progess or don´t got states");
    }
  }


  otaDevice(index) {

    this.currentIndex = index + 1;
    this.updateLog("OTACOMPONENT: Starting ota for device " + this.selectedDevices[index].serial);



    //se il device non é offline invio il comando ota, altrimenti skippo e passo al prossimo dei selezionati
    if (this.selectedDevices[index].state != DevicePilomat.STATE_TYPE_OFFLINE) {
      this.deviceService.sendOTACommand(this.selectedDevices[index].serial).subscribe(res => {


        let snackBarRef = this.snackBar.open("device: " + this.selectedDevices[index].serial + "-" + this.selectedDevices[index].name + " ota send successfully", "chiudi", {
          duration: 10000
        });

        // se la chiamata va a buon fine attendo 30 sec e controllo se é tornato offline
        setTimeout(() => {
          this.deviceService.sendOpenCommand(this.selectedDevices[index].serial).subscribe(res => {
            setTimeout(() => {
              if (this.selectedDevices[index].state != DevicePilomat.STATE_TYPE_OFFLINE) {

                if (index + 1 < this.selectedDevicesCount) {
                  this.updateLog("OTACOMPONENT: finished, starting next");
                  this.otaDevice(index + 1);
                } else {
                  this.updateLog("OTACOMPONENT: OTA process finished");
                  this.updating = false;
                }

              } else {
                this.updateLog("OTACOMPONENT: " + this.selectedDevices[index].serial + " 30s after ota still offline, start re-checking");
                // se non é ancora online ogni 5 secondi ricontrollo 
                // todo mettere un qualche tipo di timeout
                this.waitUntilOnline(index);
              }
            }, 60000);
          }, err => {
            this.updateLog("Error in sending open command for: " + this.selectedDevices[index].serial);
          });
        }, 15000);

      }, err => {
        let snackBarRef = this.snackBar.open("device: " + this.selectedDevices[index].serial + "-" + this.selectedDevices[index].name + " ota ERROR", "chiudi", {
          duration: 300000
        });

      });
    } else {
      setTimeout(() => {
        this.updateLog("OTACOMPONENT: skipping ota because is offline " + this.selectedDevices[index].serial);

        if (index + 1 < this.selectedDevicesCount) {
          this.otaDevice(index + 1);
        } else {
          this.updateLog("OTACOMPONENT: OTA process finished");
          this.updating = false;
        }
      }, 3000);
    }


  }


  waitUntilOnline(index) {
    this.recheckingCounter++;
    setTimeout(() => {
      if (this.selectedDevices[index].state != DevicePilomat.STATE_TYPE_OFFLINE) {
        if (index + 1 < this.selectedDevicesCount) {
          this.recheckingCounter = 0;
          this.otaDevice(index + 1);
        } else {
          this.recheckingCounter = 0;
          this.updateLog("OTACOMPONENT: OTA process finished");
          this.updating = false;
        }
      } else {
        //rilancio la stessa funzione con lo stesso indice per aspettare 5 secondi in più
        this.waitUntilOnline(index);
      }

    }, 5000);
  }

  addSelectedDevice(device) {
    if (device.selected) {
      device.selected = false;
    } else {
      device.selected = true;
    }
  }


  updateLog(text) {
    console.log(text);
    this.currentyDoing3 = this.currentyDoing2;
    this.currentyDoing2 = this.currentyDoing1;
    this.currentyDoing1 = text;
  }
}
